module.exports = __webpack_public_path__ + "static/media/111.9c9ea5ba.png";